import type { DocumentPageSchema } from '@avisoma/shared';
import StatusIndicator from '../../components/StatusIndicator';

const formatBytes = (bytes: number): string =>
  bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.round(bytes / 1024)} KB`;

const formatRows = (rows: number): string => `${rows} ${rows === 1 ? 'row' : 'rows'}`;

// Sheet rendition (DR-4357) — stamped when the splitter rendered this page's worksheet
// to HTML, which is the source the extractors read instead of the page PDF. A workbook
// holding a worksheet over the 3 MB markup cap is never split per worksheet at all, so
// its pages carry no stamp and this row simply does not render for them.
export function SheetRenditionRow({ page }: { page: DocumentPageSchema }) {
  const rendition = page.processing?.rendition;
  if (!rendition) return null;

  return (
    <div>
      <dt className="text-sm font-medium text-gray-500 dark:text-zinc-400 flex items-center gap-2 justify-between">
        <span className="flex items-center gap-2 min-w-0">
          <StatusIndicator status="done" title="Extraction reads this worksheet as HTML instead of the page PDF" />
          <span className="flex items-baseline gap-1.5 min-w-0 flex-wrap">
            <span>Sheet rendition</span>
            <span className="text-xs font-normal text-zinc-500 dark:text-zinc-400 shrink-0">
              {rendition.sheetName} · {formatRows(rendition.rows)} · {formatBytes(rendition.bytes)}
            </span>
          </span>
        </span>
      </dt>
    </div>
  );
}
